import { useQuery } from 'react-query';
import { useZoneContext } from '../../../../contexts/useZoneContext';

export const useGetAssessmentHasModelKey = 'get-assessment-has-model';

export const useGetAssessmentHasModel = () => {
    const { zoneApiClient } = useZoneContext();
    
    return useQuery({
        queryKey: [useGetAssessmentHasModelKey],
        queryFn: async () => {
            const response = await zoneApiClient.getCaseAssessmentHasModel();

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve the assessment has model info for this case.');
            }
            return response.payload;
        },
    });
};
